import { OrderLanguageMap, OrderI18nTemplate } from './orderTypes';

export const orderStatusTemplate: OrderLanguageMap<OrderI18nTemplate['status']> = {
  zh: {
    order: {
      PENDING: '订单草稿',
      PAYING: '支付中',
      PAID_SUCCESS: '付款成功',
      PAID_FAILURE: '付款失败',
      PARTIAL_PAID_SUCCESS: '部分付款成功',
      REFUNDING: '退款中',
      PARTIAL_REFUNDED: '部分退款',
      FULL_REFUNDED: '全部退款',
      CANCELLED: '已取消未支付',
    },
    label: {
      PENDING: '待处理',
      CREATING_LABEL: '面单请求中',
      LABEL_CREATED: '面单请求成功',
      LABEL_FAILED: '面单请求失败',
      LABEL_PRINTED: '面单已打印',
      TRACKING_ONLINE: '追踪已上线',
      DELIVERED: '已签收',
      CANCELLED: '已取消未支付',
      CANCELLED_REFUNDING: '已取消退款中',
      CANCELLED_REFUNDED: '已取消已退款',
      EXCEPTION: '异常件',
      FAILED: '失败',
    },
  },
  en: {
    order: {
      PENDING: 'Draft',
      PAYING: 'Paying',
      PAID_SUCCESS: 'Paid',
      PAID_FAILURE: 'Payment Failed',
      PARTIAL_PAID_SUCCESS: 'Partially Paid',
      REFUNDING: 'Refunding',
      PARTIAL_REFUNDED: 'Partially Refunded',
      FULL_REFUNDED: 'Fully Refunded',
      CANCELLED: 'Cancelled Unpaid',
    },
    label: {
      PENDING: 'Pending',
      CREATING_LABEL: 'Creating Label',
      LABEL_CREATED: 'Label Created',
      LABEL_FAILED: 'Label Failed',
      LABEL_PRINTED: 'Label Printed',
      TRACKING_ONLINE: 'Tracking Online',
      DELIVERED: 'Delivered',
      CANCELLED: 'Cancelled Unpaid',
      CANCELLED_REFUNDING: 'Cancelled Refunding',
      CANCELLED_REFUNDED: 'Cancelled Refunded',
      EXCEPTION: 'Exception',
      FAILED: 'Failed',
    },
  },
};
